export default {
  home: 'خانه',
  loginWithAnotherUser: 'ورود با کاربر دیگر',
  accessDeniedMessage: 'شما به صفحه مورد نظر دسترسی ندارید',
  accessDenied: 'محدودیت دسترسی',
};
